import isEmail from 'validator/lib/isEmail';

export const Rule = {
    email,
    length,
    truthy
};

export interface IFormInput<T> {
    readonly value: T
    readonly touched: boolean
    validate(): boolean
    // replaceValue will clones the current input, set's the new value und sets touched on true
    replaceValue(value: T): IFormInput<T>
}

export interface IFormInputValidator {
    (value: any): boolean
}

export function createFormInput<T>(value: any, touched: boolean = false, ...validators: IFormInputValidator[]): IFormInput<T> {
    return new FormInput<T>(value, touched, validators);
}

export class FormInput<T> {
    readonly value: T
    readonly touched: boolean = false
    readonly validators: IFormInputValidator[] = []

    constructor(value: T, touched: boolean = false, validators: IFormInputValidator[]) {
        this.value = value;
        this.touched = touched;
        this.validators = validators;
    }

    validate(): boolean {
        let valid = true;

        this.validators.forEach(v => {
            valid = valid && v(this.value);
        });

        return valid;
    }

    replaceValue(v: T): IFormInput<T> {
        return new FormInput<T>(v, true, this.validators);
    }
}

export function length(min: number = 1, max: number|null = null): IFormInputValidator {
    return (v: any): boolean => {
        if (v.hasOwnProperty('length')) {
            let valid = v.length >= min;
            if (max !== null) {
                valid = valid && v.length <= max;
            }

            return valid;
        }

        console.warn('validate: failed to check length property of ' + v);
        return false;
    };
}

export function email(v: any): boolean {
    return isEmail(v, { require_tld: true });
}

export function truthy(v: any): boolean {
    return v == true;
}
